var map = {
	"./bcs.png": "3GpV",
	"./bnds.png": "4Hu/",
	"./bps.png": "Rlvt",
	"./bsds.png": "4W5n",
	"./bsrm.png": "y8ny",
	"./ds.png": "A3x4",
	"./git.png": "S7gz",
	"./gkg.png": "AREm",
	"./ic_launcher_round.png": "s6zk",
	"./kkp.png": "+w/z",
	"./lks.png": "yxX+",
	"./logo.png": "7Otq",
	"./mayank.png": "Y2Vo",
	"./mvg.png": "MljK",
	"./rns.png": "Uxuk",
	"./rps.png": "JkeI",
	"./sp.png": "0Kn2",
	"./sravanotsava.png": "dOk0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 1